(() => {
  'use strict';
  const STICKY_SELECTOR = '[data-stai-sticky-atc]';
  const STICKY_BUTTON_SELECTOR = '[data-stai-sticky-submit]';
  const NATIVE_BUTTON_SELECTOR = 'button[name="add"]';
  const MOBILE_QUERY = '(max-width: 749px)';
  const initStickyAtc = (stickyBar) => {
    if (stickyBar.dataset.staiInitialized === 'true') return;
    stickyBar.dataset.staiInitialized = 'true';
    const sectionId = stickyBar.dataset.sectionId;
    const stickyButton = stickyBar.querySelector(STICKY_BUTTON_SELECTOR);
    const stickyLabel = stickyBar.querySelector('[data-stai-sticky-label]');
    if (!stickyButton) return;
    const getNativeButton = () => {
      const sectionForm = sectionId ? document.querySelector(`#product-form-${sectionId}`) : null;
      return sectionForm?.querySelector(NATIVE_BUTTON_SELECTOR) || document.querySelector(`product-form ${NATIVE_BUTTON_SELECTOR}`) || document.querySelector(NATIVE_BUTTON_SELECTOR);
    };
    const syncWithNativeButton = () => {
      const nativeButton = getNativeButton();
      if (!nativeButton) return false;
      const isDisabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = isDisabled;
      if (stickyLabel) {
        const nativeLabel = nativeButton.querySelector('span')?.textContent?.trim();
        stickyLabel.textContent = nativeLabel || 'Add to cart';
      }
      return true;
    };
    const setVisible = (visible) => {
      if (!window.matchMedia(MOBILE_QUERY).matches) {
        stickyBar.hidden = true;
        stickyBar.classList.remove('stai-sticky-atc--visible');
        return;
      }
      stickyBar.hidden = !visible;
      stickyBar.classList.toggle('stai-sticky-atc--visible', visible);
    };
    stickyButton.addEventListener('click', () => {
      const nativeButton = getNativeButton();
      if (!nativeButton) return;
      syncWithNativeButton();
      if (stickyButton.disabled || nativeButton.disabled) return;
      nativeButton.click();
    });
    const nativeButton = getNativeButton();
    if (!nativeButton) {
      stickyBar.hidden = true;
      return;
    }
    const updateFromViewport = (entry) => {
      setVisible(!entry.isIntersecting);
      syncWithNativeButton();
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => updateFromViewport(entry), {root: null, threshold: 0.01, rootMargin: '0px 0px -8px 0px'});
      observer.observe(nativeButton);
      stickyBar._staiObserver = observer;
    } else {
      setVisible(true);
      syncWithNativeButton();
    }
    const mutationObserver = new MutationObserver(() => { syncWithNativeButton(); });
    mutationObserver.observe(nativeButton, { attributes: true, childList: true, subtree: true });
    stickyBar._staiMutationObserver = mutationObserver;
    document.addEventListener('change', syncWithNativeButton, true);
    window.addEventListener('resize', syncWithNativeButton, { passive: true });
    syncWithNativeButton();
  };
  const initAll = () => { document.querySelectorAll(STICKY_SELECTOR).forEach(initStickyAtc); };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll, { once: true }); } else { initAll(); }
})();
